const strings = {
  unavailable: 'Unavailable',
  lessThanOneMinute: '< 1 min',
  minutes: (mins: number) => `${mins} min`,
  minutesSeconds: (mins: number, seconds: number) =>
    `${mins} min ${seconds} sec`,
} as const;

export default strings;
